module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/store_images/3@2x_52c89621c5ea7f42ed546468c68a2cfc.png";